import { render } from "./AddonVision.vue?vue&type=template&id=21038d3c&scoped=true"
import script from "./AddonVision.vue?vue&type=script&lang=js"
export * from "./AddonVision.vue?vue&type=script&lang=js"

import "./AddonVision.vue?vue&type=style&index=0&id=21038d3c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21038d3c"]])

export default __exports__